import { request } from "../../../utils/request";

// SAVE (create/update)

export const saveSettingsApi = (data: any) => {
  return request({
    method: "POST",
    url: "addSetting",
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

export const updateSettingsApi = (data: any) => {
  return request({
    method: "PUT",
    url: "updateSetting",
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};
// GET
export const getSettingsApi = async () => {
  return request({
    method: "GET",
    url: "getSetting",
  });
};
